import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { Breadcrumbs } from '../components/Breadcrumbs';

const MEASURES = [
  'Semantisches HTML mit klarer Überschriftenstruktur und genau einer Hauptüberschrift pro Seite',
  'Vollständige Bedienbarkeit mit der Tastatur, inklusive sichtbarem Fokus',
  'Skip-Link direkt zum Hauptinhalt',
  'Ausreichende Farbkontraste nach WCAG 2.2 AA; Markenfarben werden dafür barrierefrei abgeleitet',
  'Echte Formular-Labels und verständliche, programmatisch zugeordnete Fehlermeldungen',
  'Alt-Texte für alle informativen Bilder, dekorative Elemente sind ausgeblendet',
  'Respektierung der Systemeinstellung für reduzierte Bewegung',
  'Verzicht auf blinkende Inhalte und automatisch startende, störende Animationen',
];

export default function Barrierefreiheit() {
  return (
    <>
      <Seo
        title="Erklärung zur Barrierefreiheit | Felix Genuss"
        description="Erklärung zur Barrierefreiheit von Felix Genuss: angewandter Standard WCAG 2.2 AA, umgesetzte Massnahmen und bekannte Einschränkungen."
        path="/barrierefreiheit"
      />
      <Breadcrumbs items={[{ label: 'Startseite', href: '/' }, { label: 'Barrierefreiheit' }]} />
      <div className="container-site max-w-3xl pt-10">
        <h1 className="font-serif text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl">Erklärung zur Barrierefreiheit</h1>
        <p className="mt-6 leading-relaxed text-brand-brown/85">
          Felix Genuss soll für möglichst alle Menschen zugänglich sein. Wir richten uns bei der Entwicklung nach dem Standard <strong>WCAG 2.2, Konformitätsstufe AA</strong>. Diese Erklärung beschreibt sachlich, welche Massnahmen wir umsetzen und wo noch Einschränkungen bestehen können.
        </p>

        <section className="mt-10" aria-labelledby="bf-massnahmen">
          <h2 id="bf-massnahmen" className="font-serif text-2xl font-bold sm:text-3xl">Umgesetzte Massnahmen</h2>
          <ul className="mt-4 list-disc space-y-2 pl-6 leading-relaxed text-brand-brown/90 marker:text-brand-gold">
            {MEASURES.map((m) => (
              <li key={m}>{m}</li>
            ))}
          </ul>
        </section>

        <section className="mt-10" aria-labelledby="bf-stand">
          <h2 id="bf-stand" className="font-serif text-2xl font-bold sm:text-3xl">Stand und Einschränkungen</h2>
          <p className="mt-4 leading-relaxed text-brand-brown/85">
            Diese Website befindet sich im Aufbau. Wir prüfen die Barrierefreiheit laufend mit automatisierten Werkzeugen und manuellen Tests (Tastaturbedienung, Zoom, Kontraste). Ein automatischer Prüf-Score allein ist jedoch kein Beweis vollständiger Barrierefreiheit – deshalb nehmen wir Rückmeldungen aus der Praxis ernst.
          </p>
        </section>

        <section className="mt-10" aria-labelledby="bf-feedback">
          <h2 id="bf-feedback" className="font-serif text-2xl font-bold sm:text-3xl">Feedback</h2>
          <p className="mt-4 leading-relaxed text-brand-brown/85">
            Du stösst auf eine Barriere? Dann hilf uns, sie zu beseitigen: Schreib uns über unser{' '}
            <Link to="/kontakt" className="link-inline">Kontaktformular</Link>. Wir kümmern uns so schnell wie möglich darum.
          </p>
        </section>
      </div>
    </>
  );
}
